import { ModalDialog } from 'core-components/library/modalDialog'
import { SimplePartnerTable } from 'partner360/components/simplePartnerTable'

import { usePartnersSelect } from './hooks/usePartnersSelect'

interface IProps {
  show: boolean
  onClose: () => void
}

export const PartnersSelect = ({ show, onClose }: IProps) => {
  const { partnersListProps } = usePartnersSelect({ onClose })
  return (
    <ModalDialog
      onClose={onClose}
      show={show}
      size={'lg'}
      content={SimplePartnerTable}
      contentProps={partnersListProps}
    />
  )
}
